/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Const to control constants for image paths and crap like that.
 */

export const TICKET_TEXTURE_OPTIONS = {
	// probably legacy thing
	ATLAS_REFERENCE_ID: 'ticketTextureAtlasData',
	// Require the image so webpack copies it over.
	TEXTURE_ATLAS_IMAGE: 'assets/images/fancycanvas/ticket-textures.06.png',
	// The default URL (No cache busting). Will match the URL with this pre-load and replace it with a doctored URL.
	TEXTURE_ATLAS_IMAGE_PATH_NO_BUSTY: 'ticket-textures.06.png',
	// A doctored URL for the texture-textures.
	TEXTURE_ATLAS_IMAGE_PATH_BUSTY: 'assets/images/fancycanvas/ticket-textures.06.png',
	// Root path to where the texture atlas data file can be found. Must be a doctoredPath via require
	TEXTURE_ATLAS_PATH: 'assets/images/fancycanvas/ticket-textures.06.json',
	// The reference ID for the textures once loaded from the texture atlas.
	TEXTURE_CREW_ICON_NAME: 'crew-icon.png',
	TEXTURE_DURATION_DAYS_NAME: 'duration-days.png',
	TEXTURE_TICKET_COMPLETE_NAME: 'ticket-checkmark.png',
	TEXTURE_TICKET_CHECKMARK_BACKGROUND: 'ticket-checkmark-background.png',
	TEXTURE_CONSTRAINT_SELECTED_NAME: 'ticket-constraint-selected.png',
	TEXTURE_CONSTRAINT_SELECTED_PULL_NAME: 'ticket-constraint-selected-pull.png',
	TEXTURE_CONSTRAINT_NAME: 'ticket-constraint-texture.png',
	TEXTURE_CONSTRAINT_ASSIGNED_BORDER: 'constraint-assign-icon-border.png',
	TEXTURE_CONSTRAINT_ASSIGNED_ICON: 'constraint-assign-background.png',
	TEXTURE_ERROR_NAME: 'ticket-error-icon.png',
	TEXTURE_DEPENDENCY_ERROR_NAME: 'dependencies-error-icon.png',
	TEXTURE_MILESTONE_NAME: 'ticket-milestone-texture.png',
	TEXTURE_MILESTONE_SELECTED_NAME: 'ticket-milestone-selected.png',
	TEXTURE_MILESTONE_SELECTED_PULL_NAME: 'ticket-milestone-selected-pull.png',
	TEXTURE_PINNED_BACKGROUND_NAME: 'ticket-pinned-background.png',
	TEXTURE_PINNED_NAMED: 'ticket-pinned.png',
	TEXTURE_PIN_DASH_TEXTURE: 'assets/images/fancycanvas/ticket-pin-dash.png',
	TEXTURE_TICKET_HANDLES: 'ticket-with-handles.png',
	TEXTURE_TICKET_THING: 'thing.png',
	TEXTURE_DEPENDENCY_ARROWHEAD: 'arrow-head.png',
	TEXTURE_ARROW: 'arrow.png',
	TEXTURE_TICKET_OVERLAP: 'assets/images/fancycanvas/ticket-overlap.png',
	TEXTURE_LOCK_ICON: 'anchor-icon.png',
	TEXTURE_UNLOCK_ICON: 'anchor-cross-icon.png',
	TEXTURE_ROUNDED_CHECKBOX: 'work-day-check.png',
	TEXTURE_WORK_DAYS: 'work-day-box.png',
	TEXTURE_ORANGE_TRIANGLE: 'orange-triangle.png',
	TEXTURE_TICKET_START_WORK_DARK: 'ticket-start-work-dark.png',
	TEXTURE_TICKET_START_WORK_LIGHT: 'ticket-start-work-light.png',
	TEXTURE_TICKET_ATLAS_REFERENCE: 'ticketTextureAtlas',
	TEXTURE_TIMELINE_MILESTONE_ICON: 'milestone-icon.png',
	TEXTURE_TIMELINE_INDICATOR_ARROW: 'orange-triangle.png',
	TEXTURE_TIMELINE_CHEVRON_LEFT: 'chevron_left.png',
	TEXTURE_TIMELINE_CHEVRON_RIGHT: 'chevron_right.png',
};
